import React from "react";
import { Map, fromJS } from 'immutable';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import TextField from '@material-ui/core/TextField';

import Widget from "components/Widget/index";
import { albama, allProperties, colorado, newJercy } from "app/routes/dashboard/routes/Listing/data"
import { connect } from 'react-redux';

import CardBox from 'components/CardBox/index';
import Button from '@material-ui/core/Button';
import firebase from "firebase";


class Folder {
    constructor(createdById, hasNews, name) {

        this.createdById = createdById;
        this.hasNews = hasNews;
        this.name = name;
    }
}

class ModuleNewFolder extends React.Component {

    state = {
        activeTab: '1',
        loader: false,
        folderName: ''
    };





    render() {



        const style = {

            width: '100vh',
            display: 'flex',
        };



        return (



            <div className="row">



                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <div className="form-group">
                    <TextField
                        label={'Inserisci nome cartella'}
                        fullWidth
                        onChange={(event) => this.setState({ folderName: event.target.value })}
                        defaultValue={''}
                        margin="normal"
                        className="mt-1 my-sm-3"
                    />
                </div>

                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                    <Button onClick={() => {

                    var authID = localStorage.getItem('user_id');
                    var projectID = localStorage.getItem('project_id');
                    var folderName = this.state.folderName;

                    var folder = new Folder(authID, false, folderName);

                    if (folderName.length > 1) {

                        firebase.database().ref('folder_list/' + authID + '/' + projectID + '')
                            .push(folder).then((data) => {
                                //success callback
                                alert("Cartella creata con successo");
                                console.log('data ', data)
                            }).catch((error) => {
                                //error callback
                                console.log('error ', error)
                            });
                    }



                }} variant="contained" color="primary">
                    CREA
                    </Button>


            </div>


        )
    }


}




export default ModuleNewFolder;

